import { NSCard } from 'bricks';
import EmptyState from 'components/EmptyState/EmptyState';
import { IExtractedSource, IExtractedUse } from 'types/db/ExtractedProForma';
import { buildPeriodColumns } from './helpers';
import SourcesTable from './SourcesTable/SourcesTable';
import UsesTable from './UsesTable/UsesTable';

export interface SourcesAndUsesProps {
    uses: IExtractedUse[];
    sources: IExtractedSource[];
}

const SourcesAndUses = ({ uses, sources }: SourcesAndUsesProps) => {
    if (uses.length === 0 && sources.length === 0) {
        return (
            <EmptyState
                title="This extraction has no sources and uses detail."
                subtitle="Extract the workbook again to see budget lines and cash flows."
            />
        );
    }

    const periodColumns = buildPeriodColumns([
        ...uses.flatMap(use => use.budgetLines.map(line => line.periods)),
        ...sources.map(source => source.periods),
    ]);

    return (
        <>
            <NSCard className="NSCard--level-2 p-3 mb-3">
                <h4 className="text-dark mt-0 mb-2">Uses</h4>
                <UsesTable uses={uses} periodColumns={periodColumns} />
            </NSCard>
            <NSCard className="NSCard--level-2 p-3">
                <h4 className="text-dark mt-0 mb-2">Sources</h4>
                <SourcesTable sources={sources} periodColumns={periodColumns} />
            </NSCard>
        </>
    );
};

export default SourcesAndUses;
